const getEnabledHosts = (): string[] =>
  (process.env.NEXT_PUBLIC_COVEO_ANALYTICS_HOSTS || '')
    .split(',')
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean);

export const isCoveoAnalyticsEnabled = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const enabledHosts = getEnabledHosts();

  if (enabledHosts.length === 0) {
    return true;
  }

  return enabledHosts.includes(window.location.hostname.toLowerCase());
};

export default isCoveoAnalyticsEnabled;
